<template>
    <b-container class="">
        <b-row id="triggerStory1">
            <b-col id="triggerStories" cols="12">
                <h2 class="storiesTitle tac">{{$t('stories.title')}}</h2>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <swiper :options="swiperOption" ref="storiesSwiper">
                    <swiper-slide v-for="(story, i) in myJson.stories" :key="i">
                        <div class="Story">
                            <img class="storyImg" :src="getImgUrl($t('stories.stories['+i+'].img'))" alt="Products Owners">
                            <p class="storyMsg" v-html="$t('stories.stories['+i+'].msg')"></p>
                            <p class="storyName">{{$t('stories.stories['+i+'].name')}}</p>
                            <p class="storyPos">{{$t('stories.stories['+i+'].position')}}</p>
                            <p class="storyComp">{{$t('stories.stories['+i+'].company')}}</p>
                        </div>
                    </swiper-slide>

                    <!-- Optional controls -->
                    <!-- <div class="swiper-pagination"  slot="pagination"></div> -->
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </b-col>
        </b-row>


    </b-container>
</template>

<script>
var w = window.innerWidth;
var slides = 3;

if(w < 768) {
  slides = 1;
} else if (w < 1000) {
  slides = 2;
}

// import Story from "./Story.vue"
import json from '@/locales/en.json'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name:'Stories',
    data: function() {
        return {
            myJson: json.stories,
            swiperOption: {
                loop: true,
                slidesPerView: slides,
                spaceBetween: 60,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    methods: {
        getImgUrl: function(img) {
            return require('@/assets/imagesHome/'+img)
        }
    },
    computed: {
      swiper() {
        return this.$refs.storiesSwiper.swiper
      }
    },
    components: {
        // Story,
        swiper,
        swiperSlide
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/stories.scss';
.swiper-button-next{
  background-image: url('../../assets/rightArrow.png');
}

.swiper-button-prev{
  background-image: url('../../assets/leftArrow.png');
  /* margin-left:915px; */
}
</style>
